import React from 'react';
import LastFmNowPlaying, { LastFmNowPlayingStyles } from './LastFmNowPlaying';
import './NowPlayingModal.css';

export const SpotifyWaves = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
    <path d="M5 8c5-1.4 10-0.6 13.5 1.8" />
    <path d="M5.5 11.6c4.4-1.1 8.6-0.5 12 1.6" />
    <path d="M6.2 15.2c3.4-0.9 6.4-0.6 9.3 1" />
  </svg>
);

export default function NowPlayingModal({ open, onClose }) {
  if (!open) return null;
  return (
    <div className="np-overlay" onClick={onClose}>
      <LastFmNowPlayingStyles />
      <div className="np-box" onClick={(e) => e.stopPropagation()}>
        <button className="np-close" onClick={onClose} aria-label="Close">×</button>
        <div className="np-icon">
          <SpotifyWaves />
        </div>
        <div className="np-heading">What I'm listening to</div>
        <LastFmNowPlaying
          username="xoialexiox"
          apiKey={process.env.REACT_APP_LASTFM_API_KEY}
          pollInterval={30000}
        />
      </div>
    </div>
  );
}
